// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Main wrapper */
.wrapper-foodspot {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  /* Left informational panel */
  /* Right form panel */
}
.wrapper-foodspot .left {
  width: 35%;
  background: #f3f3f3;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
}
.wrapper-foodspot .left h3 {
  font-size: 17px;
  line-height: 24px;
  margin: 0 0 20px 0;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
}
.wrapper-foodspot .left p {
  margin: 0;
  line-height: 22px;
  color: var(--ion-color-secondary);
  font-size: 14px;
}
.wrapper-foodspot .left a {
  text-decoration: none;
  font-weight: bold;
  color: var(--ion-color-primary);
}
.wrapper-foodspot .left a:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.wrapper-foodspot .right {
  width: 65%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background: white;
  /* Header section */
  /* Input section */
  /* Spacer for layout */
}
.wrapper-foodspot .right .header-section {
  padding: 20px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid rgb(243, 243, 243);
  /* Close button */
}
.wrapper-foodspot .right .header-section h2 {
  margin: 0;
  font-size: 18px;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
}
.wrapper-foodspot .right .header-section .close-button {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.wrapper-foodspot .right .header-section .close-button:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.wrapper-foodspot .right .header-section .close-button:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.wrapper-foodspot .right .header-section .close-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.wrapper-foodspot .right .header-section .close-button:active {
  transform: translateY(-50%) scale(0.95);
}
.wrapper-foodspot .right .header-section .close-button ion-icon {
  font-size: 24px;
  color: var(--ion-color-secondary);
}
.wrapper-foodspot .right .input-section {
  width: 100%;
  padding: 30px 20px;
  flex: 1;
  /* Code form */
  /* Input block */
}
.wrapper-foodspot .right .input-section p {
  margin: 0 0 20px 0;
  line-height: 22px;
  color: var(--ion-color-secondary);
  font-size: 14px;
}
.wrapper-foodspot .right .input-section .code-form {
  width: 100%;
}
.wrapper-foodspot .right .input-section .input-block {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 15px;
  /* Input field */
  /* Submit button */
}
.wrapper-foodspot .right .input-section .input-block .code-input {
  flex: 1;
  border: 2px solid #f3f3f3;
  border-radius: 20px;
  padding: 0;
  --padding-top: 15px;
  --padding-bottom: 15px;
  --padding-start: 20px;
  --padding-end: 20px;
  --highlight-color-focused: var(--ion-color-primary);
  --border-color: transparent;
  --box-shadow: none;
  cursor: text;
  font-size: 16px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  /* Focus styles */
  /* Error state */
  /* Placeholder styling */
}
.wrapper-foodspot .right .input-section .input-block .code-input:focus-within {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.wrapper-foodspot .right .input-section .input-block .code-input.error {
  border-color: #d32f2f;
}
.wrapper-foodspot .right .input-section .input-block .code-input.error:focus-within {
  box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.25);
}
.wrapper-foodspot .right .input-section .input-block .code-input::placeholder {
  color: #999;
  opacity: 1;
}
.wrapper-foodspot .right .input-section .input-block .submit-button {
  --background: var(--ion-color-primary);
  --color: white;
  --border-radius: 20px;
  --padding-top: 15px;
  --padding-bottom: 15px;
  --padding-start: 25px;
  --padding-end: 25px;
  text-transform: capitalize;
  font-family: AppFontBold, sans-serif;
  min-width: 100px;
  /* Focus styles */
  /* Disabled state */
}
.wrapper-foodspot .right .input-section .input-block .submit-button:focus {
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.4);
}
.wrapper-foodspot .right .input-section .input-block .submit-button:disabled {
  --background: #cccccc;
  --color: #666666;
  cursor: not-allowed;
}
.wrapper-foodspot .right .spacer {
  height: 20px;
}

/* Error message styling */
.error-message {
  margin-top: 10px;
}
.error-message span {
  color: #d32f2f;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  /* Add icon before error text */
}
.error-message span::before {
  content: "⚠";
  margin-right: 5px;
  font-size: 14px;
}

/* Remove default input underline */
ion-input.no-underline {
  --border-color: transparent;
  --box-shadow: none;
  --highlight-color: transparent;
}

/* High contrast mode enhancements */
.bsg-high-contrast .wrapper-foodspot {
  border: 2px solid black;
}
.bsg-high-contrast .wrapper-foodspot .left {
  background: white;
  border-right: 2px solid black;
}
.bsg-high-contrast .wrapper-foodspot .left h3,
.bsg-high-contrast .wrapper-foodspot .left p {
  color: black !important;
}
.bsg-high-contrast .wrapper-foodspot .left a {
  color: #0078d7 !important;
  text-decoration: underline;
}
.bsg-high-contrast .wrapper-foodspot .right .header-section {
  border-bottom: 2px solid black;
}
.bsg-high-contrast .wrapper-foodspot .right .header-section h2 {
  color: black !important;
}
.bsg-high-contrast .wrapper-foodspot .right .header-section .close-button:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .wrapper-foodspot .right .header-section .close-button ion-icon {
  color: black !important;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section p {
  color: black !important;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .code-input {
  border-color: black;
  background: white;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .code-input:focus-within {
  border-color: #0078d7;
  box-shadow: 0 0 0 3px rgba(0, 120, 215, 0.25);
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .code-input.error {
  border-color: black;
  border-style: dashed;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .submit-button {
  --background: black;
  --color: white;
  border: 2px solid white;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .submit-button span {
  color: white !important;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .submit-button:focus {
  box-shadow: 0 0 0 3px #0078d7;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .submit-button:disabled {
  --background: #666666;
  border: 1px dashed black;
}
.bsg-high-contrast .error-message span {
  color: black !important;
  background: #ffcccc;
  padding: 5px;
  border: 1px solid black;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .wrapper-foodspot {
    flex-direction: column;
    height: auto;
  }
  .wrapper-foodspot .left {
    width: 100%;
    height: auto;
    padding: 15px;
  }
  .wrapper-foodspot .right {
    width: 100%;
  }
  .wrapper-foodspot .right .header-section {
    padding: 15px 20px;
  }
  .wrapper-foodspot .right .header-section .close-button {
    right: 15px;
  }
  .wrapper-foodspot .right .input-section {
    padding: 20px 15px;
  }
  .wrapper-foodspot .right .input-section .input-block {
    flex-direction: column;
    gap: 15px;
  }
  .wrapper-foodspot .right .input-section .input-block .submit-button {
    width: 100%;
  }
}
ion-button {
  color: white !important;
}
ion-button span {
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/enter-foodspot-code-modal/enter-foodspot-code-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,4BAAA;AACA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAED;;AACA,iBAAA;AACA;EACC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EAEA,6BAAA;EAqCA,qBAAA;AAnCD;AADC;EACC,UAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;AAGF;AADE;EACC,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;AAGH;AAAE;EACC,SAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;AAEH;AACE;EACC,qBAAA;EACA,iBAAA;EACA,+BAAA;AACH;AACG;EACC,2CAAA;EACA,mBAAA;AACJ;AAKC;EACC,UAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,iBAAA;EAEA,mBAAA;EA0DA,kBAAA;EA4FA,sBAAA;AAxJF;AAGE;EACC,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,2CAAA;EASA,iBAAA;AATH;AAEG;EACC,SAAA;EACA,eAAA;EACA,iCAAA;EACA,oCAAA;AAAJ;AAIG;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AAjBJ;AACI;EACC,2CAAA;EACA,mBAAA;AACL;AAGI;EACC,2CAAA;EACA,mBAAA;AADL;AAKI;EACC,qCAAA;AAHL;AAOI;EACC,uCAAA;AALL;AAQI;EACC,eAAA;EACA,iCAAA;AANL;AAYE;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EASA,cAAA;EAKA,gBAAA;AAtBH;AAUG;EACC,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;AARJ;AAYG;EACC,WAAA;AAVJ;AAcG;EACC,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EAEA,gBAAA;EAuCA,kBAAA;AAnDJ;AAaI;EACC,OAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mDAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,wDAAA;EAEA,iBAAA;EAMA,gBAAA;EASA,wBAAA;AAzBL;AAWK;EACC,sCAAA;EACA,8CAAA;AATN;AAaK;EACC,qBAAA;AAXN;AAaM;EACC,6CAAA;AAXP;AAgBK;EACC,WAAA;EACA,UAAA;AAdN;AAmBI;EACC,sCAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,0BAAA;EACA,oCAAA;EACA,gBAAA;EAEA,iBAAA;EAKA,mBAAA;AAtBL;AAkBK;EACC,6CAAA;AAhBN;AAoBK;EACC,qBAAA;EACA,gBAAA;EACA,mBAAA;AAlBN;AAyBE;EACC,YAAA;AAvBH;;AA4BA,0BAAA;AACA;EACC,gBAAA;AAzBD;AA2BC;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EAEA,+BAAA;AA1BF;AA2BE;EACC,YAAA;EACA,iBAAA;EACA,eAAA;AAzBH;;AA8BA,mCAAA;AACA;EACC,2BAAA;EACA,kBAAA;EACA,8BAAA;AA3BD;;AA8BA,oCAAA;AAEC;EACC,uBAAA;AA5BF;AA8BE;EACC,iBAAA;EACA,6BAAA;AA5BH;AA8BG;;EAEC,uBAAA;AA5BJ;AA+BG;EACC,yBAAA;EACA,0BAAA;AA7BJ;AAkCG;EACC,8BAAA;AAhCJ;AAkCI;EACC,uBAAA;AAhCL;AAoCK;EACC,0BAAA;AAlCN;AAqCK;EACC,uBAAA;AAnCN;AAyCI;EACC,uBAAA;AAvCL;AA2CK;EACC,mBAAA;EACA,iBAAA;AAzCN;AA2CM;EACC,qBAAA;EACA,6CAAA;AAzCP;AA4CM;EACC,mBAAA;EACA,oBAAA;AA1CP;AA8CK;EACC,mBAAA;EACA,cAAA;EACA,uBAAA;AA5CN;AA6CM;EACC,uBAAA;AA3CP;AA6CM;EACC,6BAAA;AA3CP;AA8CM;EACC,qBAAA;EACA,wBAAA;AA5CP;AAoDC;EACC,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AAlDF;;AAsDA,2BAAA;AACA;EACC;IACC,sBAAA;IACA,YAAA;EAnDA;EAqDA;IACC,WAAA;IACA,YAAA;IACA,aAAA;EAnDD;EAsDA;IACC,WAAA;EApDD;EAsDC;IACC,kBAAA;EApDF;EAsDE;IACC,WAAA;EApDH;EAwDC;IACC,kBAAA;EAtDF;EAwDE;IACC,sBAAA;IACA,SAAA;EAtDH;EAwDG;IACC,WAAA;EAtDJ;AACF;AA4DA;EACC,uBAAA;AA1DD;AA2DC;EACC,uBAAA;AAzDF","sourcesContent":["/* Accessibility utilities */\n.visually-hidden {\n\tposition: absolute;\n\twidth: 1px;\n\theight: 1px;\n\tmargin: -1px;\n\tpadding: 0;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\twhite-space: nowrap;\n\tborder: 0;\n}\n\n/* Main wrapper */\n.wrapper-foodspot {\n\tdisplay: flex;\n\talign-items: center;\n\theight: 100%;\n\twidth: 100%;\n\tborder-radius: 20px;\n\toverflow: hidden;\n\tbox-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n\n\t/* Left informational panel */\n\t.left {\n\t\twidth: 35%;\n\t\tbackground: #f3f3f3;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-direction: column;\n\t\tpadding: 20px;\n\n\t\th3 {\n\t\t\tfont-size: 17px;\n\t\t\tline-height: 24px;\n\t\t\tmargin: 0 0 20px 0;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t}\n\n\t\tp {\n\t\t\tmargin: 0;\n\t\t\tline-height: 22px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-size: 14px;\n\t\t}\n\n\t\ta {\n\t\t\ttext-decoration: none;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: var(--ion-color-primary);\n\n\t\t\t&:focus {\n\t\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\t\toutline-offset: 2px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Right form panel */\n\t.right {\n\t\twidth: 65%;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-direction: column;\n\t\tbackground: white;\n\n\t\t/* Header section */\n\t\t.header-section {\n\t\t\tpadding: 20px;\n\t\t\ttext-align: center;\n\t\t\tposition: relative;\n\t\t\tborder-bottom: 1px solid rgba(243, 243, 243, 1);\n\n\t\t\th2 {\n\t\t\t\tmargin: 0;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t}\n\n\t\t\t/* Close button */\n\t\t\t.close-button {\n\t\t\t\tposition: absolute;\n\t\t\t\tright: 20px;\n\t\t\t\ttop: 50%;\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tbackground: transparent;\n\t\t\t\tborder: none;\n\t\t\t\tpadding: 8px;\n\t\t\t\tcursor: pointer;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\n\t\t\t\t/* Focus styles */\n\t\t\t\t&:focus {\n\t\t\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\t\t\toutline-offset: 2px;\n\t\t\t\t}\n\n\t\t\t\t/* Keyboard focus styles */\n\t\t\t\t&:focus-visible {\n\t\t\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\t\t\toutline-offset: 2px;\n\t\t\t\t}\n\n\t\t\t\t/* Hover state */\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t\t\t\t}\n\n\t\t\t\t/* Active state */\n\t\t\t\t&:active {\n\t\t\t\t\ttransform: translateY(-50%) scale(0.95);\n\t\t\t\t}\n\n\t\t\t\tion-icon {\n\t\t\t\t\tfont-size: 24px;\n\t\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/* Input section */\n\t\t.input-section {\n\t\t\twidth: 100%;\n\t\t\tpadding: 30px 20px;\n\t\t\tflex: 1;\n\n\t\t\tp {\n\t\t\t\tmargin: 0 0 20px 0;\n\t\t\t\tline-height: 22px;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\n\t\t\t/* Code form */\n\t\t\t.code-form {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Input block */\n\t\t\t.input-block {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tgap: 10px;\n\t\t\t\tmargin-bottom: 15px;\n\n\t\t\t\t/* Input field */\n\t\t\t\t.code-input {\n\t\t\t\t\tflex: 1;\n\t\t\t\t\tborder: 2px solid #f3f3f3;\n\t\t\t\t\tborder-radius: 20px;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\t--padding-top: 15px;\n\t\t\t\t\t--padding-bottom: 15px;\n\t\t\t\t\t--padding-start: 20px;\n\t\t\t\t\t--padding-end: 20px;\n\t\t\t\t\t--highlight-color-focused: var(--ion-color-primary);\n\t\t\t\t\t--border-color: transparent;\n\t\t\t\t\t--box-shadow: none;\n\t\t\t\t\tcursor: text;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\ttransition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n\t\t\t\t\t/* Focus styles */\n\t\t\t\t\t&:focus-within {\n\t\t\t\t\t\tborder-color: var(--ion-color-primary);\n\t\t\t\t\t\tbox-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n\t\t\t\t\t}\n\n\t\t\t\t\t/* Error state */\n\t\t\t\t\t&.error {\n\t\t\t\t\t\tborder-color: #d32f2f;\n\n\t\t\t\t\t\t&:focus-within {\n\t\t\t\t\t\t\tbox-shadow: 0 0 0 3px rgba(211, 47, 47, 0.25);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t/* Placeholder styling */\n\t\t\t\t\t&::placeholder {\n\t\t\t\t\t\tcolor: #999;\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t/* Submit button */\n\t\t\t\t.submit-button {\n\t\t\t\t\t--background: var(--ion-color-primary);\n\t\t\t\t\t--color: white;\n\t\t\t\t\t--border-radius: 20px;\n\t\t\t\t\t--padding-top: 15px;\n\t\t\t\t\t--padding-bottom: 15px;\n\t\t\t\t\t--padding-start: 25px;\n\t\t\t\t\t--padding-end: 25px;\n\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\tmin-width: 100px;\n\n\t\t\t\t\t/* Focus styles */\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tbox-shadow: 0 0 0 3px rgba(113, 167, 97, 0.4);\n\t\t\t\t\t}\n\n\t\t\t\t\t/* Disabled state */\n\t\t\t\t\t&:disabled {\n\t\t\t\t\t\t--background: #cccccc;\n\t\t\t\t\t\t--color: #666666;\n\t\t\t\t\t\tcursor: not-allowed;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/* Spacer for layout */\n\t\t.spacer {\n\t\t\theight: 20px;\n\t\t}\n\t}\n}\n\n/* Error message styling */\n.error-message {\n\tmargin-top: 10px;\n\n\tspan {\n\t\tcolor: #d32f2f;\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t/* Add icon before error text */\n\t\t&::before {\n\t\t\tcontent: '⚠';\n\t\t\tmargin-right: 5px;\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n}\n\n/* Remove default input underline */\nion-input.no-underline {\n\t--border-color: transparent;\n\t--box-shadow: none;\n\t--highlight-color: transparent;\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n\t.wrapper-foodspot {\n\t\tborder: 2px solid black;\n\n\t\t.left {\n\t\t\tbackground: white;\n\t\t\tborder-right: 2px solid black;\n\n\t\t\th3,\n\t\t\tp {\n\t\t\t\tcolor: black !important;\n\t\t\t}\n\n\t\t\ta {\n\t\t\t\tcolor: #0078d7 !important;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t.right {\n\t\t\t.header-section {\n\t\t\t\tborder-bottom: 2px solid black;\n\n\t\t\t\th2 {\n\t\t\t\t\tcolor: black !important;\n\t\t\t\t}\n\n\t\t\t\t.close-button {\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\toutline: 3px solid #0078d7;\n\t\t\t\t\t}\n\n\t\t\t\t\tion-icon {\n\t\t\t\t\t\tcolor: black !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.input-section {\n\t\t\t\tp {\n\t\t\t\t\tcolor: black !important;\n\t\t\t\t}\n\n\t\t\t\t.input-block {\n\t\t\t\t\t.code-input {\n\t\t\t\t\t\tborder-color: black;\n\t\t\t\t\t\tbackground: white;\n\n\t\t\t\t\t\t&:focus-within {\n\t\t\t\t\t\t\tborder-color: #0078d7;\n\t\t\t\t\t\t\tbox-shadow: 0 0 0 3px rgba(0, 120, 215, 0.25);\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&.error {\n\t\t\t\t\t\t\tborder-color: black;\n\t\t\t\t\t\t\tborder-style: dashed;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.submit-button {\n\t\t\t\t\t\t--background: black;\n\t\t\t\t\t\t--color: white;\n\t\t\t\t\t\tborder: 2px solid white;\n\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\tcolor: white !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\tbox-shadow: 0 0 0 3px #0078d7;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&:disabled {\n\t\t\t\t\t\t\t--background: #666666;\n\t\t\t\t\t\t\tborder: 1px dashed black;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.error-message span {\n\t\tcolor: black !important;\n\t\tbackground: #ffcccc;\n\t\tpadding: 5px;\n\t\tborder: 1px solid black;\n\t}\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n\t.wrapper-foodspot {\n\t\tflex-direction: column;\n\t\theight: auto;\n\n\t\t.left {\n\t\t\twidth: 100%;\n\t\t\theight: auto;\n\t\t\tpadding: 15px;\n\t\t}\n\n\t\t.right {\n\t\t\twidth: 100%;\n\n\t\t\t.header-section {\n\t\t\t\tpadding: 15px 20px;\n\n\t\t\t\t.close-button {\n\t\t\t\t\tright: 15px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.input-section {\n\t\t\t\tpadding: 20px 15px;\n\n\t\t\t\t.input-block {\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tgap: 15px;\n\n\t\t\t\t\t.submit-button {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\nion-button {\n\tcolor: white !important;\n\tspan {\n\t\tcolor: white !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
